import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import "./InvestmentOpportnites.css";

import room1 from "../../images/gallery/room/room5.png";
import city3 from "../../images/city3.png";
import nature2 from "../../images/nature2.png";
import city4 from "../../images/city4.png";
import city5 from "../../images/city5.png";
import nature3 from "../../images/nature3.png";
import nature4 from "../../images/nature4.png";
import city6 from "../../images/city6.png";

function InvestmentOpportnites() {
	useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="investment-opportunities">
      <div className="investment-opportunities__preview">
        <h1 className="investment-opportunities__title">
          INVESTMENT OPPORTUNITIES
        </h1>
        <h2 className="investment-opportunities__subtitle">
          MIKDASH DEVELOPMENT
        </h2>
      </div>
      <p className="investment-opportunities__text">
        We offer unique investment opportunities in the real estate and
        construction sector. Our years of experience and deep market knowledge
        allow us to create high-yield projects while minimizing risks for our
        investors.
      </p>
      <div className="investment-opportunities__photo-container">
        <div className="investment-opportunities__card card-1">
          <h3 className="investment-opportunities__card-title">
            High-Yield Projects
          </h3>
          <p className="investment-opportunities__card-text">
            Our investment projects are designed to generate high returns while
            minimizing risks.
          </p>
        </div>
        <div className="investment-opportunities__card card-2">
          <h3 className="investment-opportunities__card-title">
            Risk Management
          </h3>
          <p className="investment-opportunities__card-text">
            Our approach ensures effective risk management through diversified
            portfolios.
          </p>
        </div>
        <div className="investment-opportunities__card card-3">
          <h3 className="investment-opportunities__card-title">
            Sustainable Growth
          </h3>
          <p className="investment-opportunities__card-text">
            We focus on long-term sustainable growth in the construction and
            real estate sectors.
          </p>
        </div>
        <div className="investment-opportunities__card card-4">
          <h3 className="investment-opportunities__card-title">
            Expert Consultation
          </h3>
          <p className="investment-opportunities__card-text">
            Our experts provide tailored consultation for your investment needs.
          </p>
        </div>
      </div>
      <div className="investment-opportunities__gallery">
        <h4 className="investment-opportunities__gallery-title">GALLERY</h4>
        <p className="investment-opportunities__gallery-text">
          Explore our investment opportunities through our gallery, showcasing
          successful projects and investment avenues.
        </p>
        <div className="investment-opportunities__gallery-container">
          <img
            className="investment-opportunities__img"
            src={room1}
            alt="kitchen"
          />
          <img
            className="investment-opportunities__img"
            src={city3}
            alt="bathroom"
          />
          <img
            className="investment-opportunities__img"
            src={nature3}
            alt="kitchen"
          />
          <img
            className="investment-opportunities__img"
            src={city4}
            alt="bathroom"
          />
          <img
            className="investment-opportunities__img"
            src={city5}
            alt="kitchen"
          />
          <img
            className="investment-opportunities__img"
            src={nature3}
            alt="kitchen"
          />
          <img
            className="investment-opportunities__img"
            src={nature4}
            alt="kitchen"
          />
          <img
            className="investment-opportunities__img"
            src={city6}
            alt="bathroom"
          />
        </div>
        <Link to="/gallery" className="property-development__button">
          Go to Gallery
        </Link>
      </div>
    </section>
  );
}

export default InvestmentOpportnites;